var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalMemory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9534",
    "data-name": "Group 9534",
    transform: "translate(-3.46 -3.46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9534-2",
    "data-name": "Group 9534",
    transform: "translate(3.46 3.46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3532",
    "data-name": "Path 3532",
    d: "M165.686,143.635H148.007a4.377,4.377,0,0,0-4.372,4.372v17.679a4.377,4.377,0,0,0,4.372,4.372h17.679a4.377,4.377,0,0,0,4.372-4.372V148.007A4.377,4.377,0,0,0,165.686,143.635Zm.61,22.051a.611.611,0,0,1-.61.61H148.007a.611.611,0,0,1-.61-.61V148.007a.611.611,0,0,1,.61-.61h17.679a.611.611,0,0,1,.61.61Z",
    transform: "translate(-129.846 -129.846)",
    fill: "#5ca700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3533",
    "data-name": "Path 3533",
    d: "M55.749,26.774a1.711,1.711,0,0,0,0-3.421H50.27V19.83h5.479a1.711,1.711,0,0,0,0-3.421H50.212a6.631,6.631,0,0,0-5.7-5.7V5.171a1.711,1.711,0,1,0-3.421,0V10.65H37.567V5.171a1.711,1.711,0,1,0-3.421,0V10.65H26.774V5.171a1.711,1.711,0,1,0-3.421,0V10.65H19.83V5.171a1.711,1.711,0,1,0-3.421,0v5.537a6.631,6.631,0,0,0-5.7,5.7H5.171a1.711,1.711,0,1,0,0,3.421H10.65v3.523H5.171a1.711,1.711,0,1,0,0,3.421H10.65v7.372H5.171a1.711,1.711,0,0,0,0,3.421H10.65V41.09H5.171a1.711,1.711,0,1,0,0,3.421h5.537a6.631,6.631,0,0,0,5.7,5.7v5.537a1.711,1.711,0,0,0,3.421,0V50.27h3.523v5.479a1.711,1.711,0,0,0,3.421,0V50.27h7.372v5.479a1.711,1.711,0,0,0,3.421,0V50.27H41.09v5.479a1.711,1.711,0,0,0,3.421,0V50.212a6.631,6.631,0,0,0,5.7-5.7h5.537a1.711,1.711,0,0,0,0-3.421H50.27V37.567h5.479a1.711,1.711,0,0,0,0-3.421H50.27V26.774Zm-8.9,16.876a3.2,3.2,0,0,1-3.2,3.2H17.27a3.2,3.2,0,0,1-3.2-3.2V17.27a3.2,3.2,0,0,1,3.2-3.2H43.65a3.2,3.2,0,0,1,3.2,3.2Z",
    transform: "translate(-3.46 -3.46)",
    fill: "#5ca700"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalMemory);
export default __webpack_public_path__ + "static/media/totalMemory.ded696268194622c72f29ddba8a94b62.svg";
export { ForwardRef as ReactComponent };